import type { PublicProduct } from "@/types/models";
import ProductCard from "./ProductCard";

export interface ProductGridProps {
  products: PublicProduct[];
  storeSlug: string;
}

export default function ProductGrid({ products, storeSlug }: ProductGridProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {products.map((product) => (
        <ProductCard key={product.id} product={product} storeSlug={storeSlug} />
      ))}
    </div>
  );
}
